import { Link } from "react-router-dom";

export const Header = ({ showRestart, onRestart, extraLink }) => (
  <header className="cd-header" data-testid="cd-header">
    <div className="cd-header-inner">
      <Link to="/" className="cd-logo" data-testid="cd-logo">
        <img
          src="/club-dink-logo.webp"
          alt="Club Dink Supply"
          className="cd-logo-img"
        />
        <span className="cd-logo-text">Paddle Finder</span>
      </Link>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {extraLink}
        {showRestart && (
          <button
            className="cd-btn-ghost"
            onClick={onRestart}
            data-testid="cd-restart-btn"
          >
            Start over
          </button>
        )}
      </div>
    </div>
  </header>
);
